import React, { useEffect, useRef, useState } from 'react'
import { BarChart, ComposedChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import GenericInput from '../../../genericComponents/input/GenericInputComponent';
import Icons from '../../../assets/icons';
import dayjs from 'dayjs';
import { formatNumber } from '../../../helper/genericFunction';
import { Factory } from 'lucide-react';
import SkeletonLoader from './dashboardComponents/SkeletonLoader';
import { getPermissionKey } from '../../../helper/permissions';
import TableLoader from '../../../genericComponents/oldGenericComponents/tableHelperComponents/TableLoader';
import TableSkeleton from '../orderTracking/TableSkeleton';
import NoDataFound from '../../../genericComponents/NoDataFound';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { getPayloadFromURLParams, setPayloadAsURLParams } from '../../../helper/URLParamsHelper';

function ProcDashBottomSection(props) {
    const { filters } = props;
    const dispatch = useDispatch();
    const digiProcStore = useSelector(state => state.digiProcStore);
    const [currentTab, setCurrentTab] = useState("vendors");
    const [performanceAnalysisData, setPerformanceAnalysisData] = useState([]);
    const [selectedItem, setSelectedItem] = useState({ displayName: "Top 5", value: 5 })
    const [graphData, setGraphData] = useState([]);
    const [graphDataRange, setGraphDataRange] = useState(null);
    const location = useLocation();
    const history = useHistory();

    // state to store user wise pi po data
    const jumpInputRef = useRef();

    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [errorOccured, setErrorOccured] = useState(false);
    const [enableJumpPage, setEnableJumpPage] = useState(false);
    const [userWiseData, setUserWiseData] = useState({
        currentPage: 1,
        maxPage: 1,
        pageSize: 10,
        pageNumber: 1,
    })

    useEffect(() => {
        dispatchHandler(dispatch, "getPiPoCreationStatsRequest", { filter: {}, displayName: "PI_PO_STAT_DATE_WISE" }, getPermissionKey("dashboard", "procurement", "view"));
        getData();
    }, []);

    useEffect(() => {
        getData();
    }, [filters])

    useEffect(() => {
        if (digiProcStore?.userWisePiPoData?.isSuccess) {
            setLoading(false)
            setErrorOccured(false)
            setUserWiseData((prevState) => ({
                ...prevState,
                currentPage: digiProcStore?.userWisePiPoData?.data?.currPage,
                maxPage: digiProcStore?.userWisePiPoData?.data?.maxPage,
                pageSize: digiProcStore?.userWisePiPoData?.data?.pageSize,
                totalRecord: digiProcStore?.userWisePiPoData?.data?.totalRecord
            }));
            setTableData(digiProcStore?.userWisePiPoData?.data?.resource);
        }
        else if (digiProcStore?.userWisePiPoData?.isError) {
            setUserWiseData((prevState) => ({
                ...prevState,
                currentPage: 1,
                maxPage: 1,
                pageSize: 10,
                pageNumber: 1,
            }));
            setLoading(false)
            setErrorOccured(true)
        }
    }, [digiProcStore?.userWisePiPoData?.isSuccess, digiProcStore?.userWisePiPoData?.isError]);

    useEffect(() => {
        let payload = {
            displayName: currentTab == "vendors" ? "TOP_VENDORS_DATA" : "TOP_ITEMS_DATA",
            filter: filters,
            pageSize: selectedItem?.value,
        }
        dispatchHandler(dispatch, "getPerformanceAnalysisRequest", payload, getPermissionKey("dashboard", "procurement", "view"));
    }, [currentTab, filters, selectedItem?.value]);

    const handleChange = (type, val) => {
        switch (type) {
            case "tab":
                setCurrentTab(val?.target?.value)
                break;
            case "itemCount":
                setSelectedItem(val)
                break;
            case "statisticsFilter":
                setGraphDataRange(val)
                if(val?.[0]?.$d && val?.[1]?.$d) {
                    dispatchHandler(dispatch, "getPiPoCreationStatsRequest", { filter: { creationTime: { from: val?.[0]?.$d ? dayjs(val?.[0]?.$d)?.format("YYYY-MM-DD") : undefined, to: val?.[1]?.$d ? dayjs(val?.[1]?.$d)?.format("YYYY-MM-DD") : undefined } }, displayName: "PI_PO_STAT_DATE_WISE" }, getPermissionKey("dashboard", "procurement", "view"));
                }
                else {
                    dispatchHandler(dispatch, "getPiPoCreationStatsRequest", { filter: {}, displayName: "PI_PO_STAT_DATE_WISE" }, getPermissionKey("dashboard", "procurement", "view"));
                }
                break;
            // case "viewVendorDetails": {
            //     // Update the url search params here.
            //     setPayloadAsURLParams({
            //         data: {
            //             ...getPayloadFromURLParams({
            //                 l: location,
            //             }),
            //             vendorDetailsConfig: {
            //                 vendorCode: val?.slcode ?? "90058"
            //             },
            //         },
            //         l: location,
            //         h: history,
            //     });
            //     break;
            // }
        }
    }

    // Function to convert the date to the desired format
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    }

    // Merging the data
    const mergeData = (data, poData) => {
        const mergedData = [];

        // Process data
        data.forEach(item => {
            let obj = {};
            obj = {
                "name": formatDate(item?.date),
                "Indents Created": item?.pi_created_count || 0,
                "Indents Approved": item?.approved_pi_count || 0,
                "Orders Created": item?.created_count || 0,
                "Orders Approved": item?.approved_count || 0,
                // "GRC Completed": item?.grc || 0
            }
            mergedData.push(obj)
        });

        return mergedData;
    }

    useEffect(() => {
        if (digiProcStore?.getPiPoCreationStatsData?.isSuccess) {
            let data = digiProcStore?.getPiPoCreationStatsData?.data;
            const result = mergeData(data);
            setGraphData(result);
        }
        if (digiProcStore?.getPerformanceAnalysisData?.isSuccess) {
            setPerformanceAnalysisData(digiProcStore?.getPerformanceAnalysisData?.data)
        }
    }, [digiProcStore?.getPiPoCreationStatsData?.isSuccess, digiProcStore?.getPerformanceAnalysisData?.isSuccess]);

    const performanceAnalysisObj = {
        vendors: {
            slname: "Supplier Name",
            slcode: "Supplier Code",
            // total_count: "Order Count",
            po_qty: "Total Qty",
            po_amount: "Total Amount",
            otif: "OTIF",
            fulfill: "Fulfillment %"
        },
        items: {
            hl1name: "Division",
            // total_count: "Order Count",
            po_qty: "Total Qty",
            po_amount: "Total Amount"
        }
    }

    const provideProps = (key) => {
        switch (key) {
            case "itemCount": return ({
                getListData: () => ([{ displayName: "Top 5", value: 5 }, { displayName: "Top 10", value: 10 }, { displayName: "Top 15", value: 15 }, { displayName: "Top 20", value: 20 }]),
                headerKeys: {
                    "displayName": {
                        value: "Name",
                    }
                },
                itemKeys: {
                    "displayName": ["displayName"]
                },
            })
            case "statisticsFilter": return ({
                hideDefaultRanges: true
            })
        }
    }

    const renderLoadingSkeleton = () => {
        return <SkeletonLoader />
    }

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div
                    className="px-3 py-2 bg-[#0F172A] text-xs space-y-2    "
                    style={{
                        fontFamily: 'poppins',
                    }}
                >
                    {payload.map((item, index) => (
                        <div className='flex items-center gap-2.5 justify-between w-[200px] font-semibold'>
                            <div className='flex items-center gap-2'>
                                <div className='h-[10px] w-[10px]' style={{ backgroundColor: item?.color }}></div>
                                <LanguageTranslator tag='p' key={index} className='mb-0 text-[#979CA7]'>{item.name}</LanguageTranslator>
                            </div>
                            <p className='mb-0 text-white'>{item.value}</p>
                        </div>
                    ))}
                </div>
            );
        }

        return null;
    };

    const disabledDate = (current) => {
        return current && current > dayjs().endOf("day");
    };

    const renderChartSkeletonLoader = () => {
        return <div className='px-7 mt-[3rem] h-[300px] w-full'><div className='px-8 h-full flex items-end gap-5 justify-between border-l border-b'>
            <div className='generic-skeleton !w-[30px] !h-[250px] !rounded-none !mb-0'></div>
            <div className='generic-skeleton !w-[30px] !h-[100px] !rounded-none !mb-0'></div>
            <div className='generic-skeleton !w-[30px] !h-[200px] !rounded-none !mb-0'></div>
            <div className='generic-skeleton !w-[30px] !h-[250px] !rounded-none !mb-0'></div>
            <div className='generic-skeleton !w-[30px] !h-[100px] !rounded-none !mb-0'></div>
            <div className='generic-skeleton !w-[30px] !h-[200px] !rounded-none !mb-0'></div>
            <div className='generic-skeleton !w-[30px] !h-[250px] !rounded-none !mb-0'></div>
        </div></div>
    }

    // Function : To get the data for the current page and tab
    const getData = (config = {}) => {
        let {
            pageNo = userWiseData?.currentPage || 1,
            size = userWiseData?.pageSize ?? 10,
            search = ""
        } = config;

        let payload = {
            displayName: "USER_WISE_PI_PO_DATA",
            pageSize: size,
            pageNo,
            filter: filters || {},
            search
        }
        setLoading(true)
        dispatchHandler(dispatch, "userWisePiPoRequest", payload, getPermissionKey("dashboard", "procurement", "view"));
    }

    const changePage = (page) => {
        setUserWiseData((prevState) => ({
            ...prevState,
            current: page,
        }));
        getData({
            pageNo: page,
        })
    }

    const setPageNumberValue = (e) => {
        let pageNumber = Number(e.target.value),
            valid = e.target.value == "" || (/^\d*$/.test(pageNumber) && pageNumber > 0 && pageNumber <= userWiseData?.maxPage);
        if (valid) {
            setUserWiseData((prevState) => ({
                ...prevState,
                pageNumber: pageNumber,
            }));
            if (e.key == "Enter" && pageNumber && pageNumber != userWiseData?.currentPage) {
                changePage(pageNumber);
                setEnableJumpPage(false);
                setTimeout(() => document.removeEventListener("click", closeJumpPage), 0)
            }
        }
    }

    const closeJumpPage = (e) => {
        if (jumpInputRef?.current && !jumpInputRef.current.contains(e.target)) {
            setEnableJumpPage(false);
            setTimeout(() => document.removeEventListener("click", closeJumpPage), 0)
        }
    }

    const handleJumpPage = () => {
        setEnableJumpPage(true);
        setTimeout(() => document.addEventListener("click", closeJumpPage), 0)
    }

    useEffect(() => {
        if(userWiseData?.search === "") {
            getData({ search: "" })
        }
    }, [userWiseData?.search])

    const renderPagination = () => {
        return <div className="new-gen-pagination">
            <div className="ngp-left">
                <div className='flex items-center gap-3'>
                    <GenericInput
                        genInputExtraClass="!m-0"
                        inputKey="search"
                        type="text"
                        value={userWiseData?.search || ""}
                        onChange={(e) => setUserWiseData((prevState) => ({
                            ...prevState,
                            search: e?.target?.value || "",
                        }))}
                        clearPressFunction={() => {
                            setUserWiseData((prevState) => ({
                                ...prevState,
                                search: "",
                            }))
                            getData({ search: "" })
                        }}
                        onKeyDown={(e) => e.key == "Enter" && getData({ search: e?.target?.value })}  
                        placeholder="Search..."
                        dependentFieldsObject={[userWiseData?.search]}
                    />
                </div>
            </div>
            {!props?.hidePaginationDropdown && <div className="ngp-right tablePagination">
                <div className="nt-btn">
                    <div className="pagination-inner">
                        <ul className="pagination-item">
                            <li>
                                <button className={`${userWiseData?.currentPage == 1 && "gen-action-btn-disable disable-"}first-btn`} disabled={userWiseData?.currentPage == 1} onClick={() => changePage(1)}>
                                    <span className="page-item-btn-inner">
                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M10.8977 6.49114C11.2557 6.84912 11.2557 7.42952 10.8977 7.7875L6.96254 11.7227L10.8977 15.6578C11.2557 16.0158 11.2557 16.5962 10.8977 16.9542C10.5397 17.3122 9.95931 17.3122 9.60133 16.9542L5.018 12.3708C4.66002 12.0129 4.66002 11.4325 5.018 11.0745L9.60133 6.49114C9.95931 6.13316 10.5397 6.13316 10.8977 6.49114Z" fill="#23235F" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M17.3143 6.49114C17.6723 6.84912 17.6723 7.42952 17.3143 7.7875L13.3792 11.7227L17.3143 15.6578C17.6723 16.0158 17.6723 16.5962 17.3143 16.9542C16.9563 17.3122 16.3759 17.3122 16.018 16.9542L11.4346 12.3708C11.0766 12.0129 11.0766 11.4325 11.4346 11.0745L16.018 6.49114C16.3759 6.13316 16.9563 6.13316 17.3143 6.49114Z" fill="#23235F" />
                                        </svg>
                                    </span>
                                </button>
                            </li>
                            <li>
                                <button className={`${userWiseData?.currentPage == 1 && "gen-action-btn-disable dis-"}prev-btn`} disabled={userWiseData?.currentPage == 1} onClick={() => changePage(userWiseData?.currentPage - 1)}>
                                    <span className="page-item-btn-inner">
                                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M6.89781 0.491142C7.2558 0.849122 7.2558 1.42952 6.89781 1.7875L2.96266 5.72266L6.89781 9.65781C7.2558 10.0158 7.2558 10.5962 6.89781 10.9542C6.53983 11.3122 5.95943 11.3122 5.60145 10.9542L1.01812 6.37084C0.660139 6.01286 0.660139 5.43246 1.01812 5.07448L5.60145 0.491142C5.95943 0.133161 6.53983 0.133161 6.89781 0.491142Z" fill="#23235F" />
                                        </svg>
                                    </span>
                                </button>
                            </li>
                            <li>
                                {!enableJumpPage ? <button className="pi-number-btn" onClick={() => handleJumpPage()}>
                                    <span>{userWiseData?.currentPage}<label>of</label>{userWiseData?.maxPage}</span>
                                </button> : <input
                                    ref={jumpInputRef}
                                    className="pinum-input"
                                    onChange={setPageNumberValue}
                                    onKeyPress={setPageNumberValue}
                                    type="number"
                                    autoComplete="off"
                                    value={userWiseData?.pageNumber}
                                />}
                            </li>
                            <li>
                                <button className={`${userWiseData?.currentPage == userWiseData?.maxPage && "gen-action-btn-disable dis-"}next-btn`} disabled={userWiseData?.currentPage == userWiseData?.maxPage} onClick={() => changePage(userWiseData?.currentPage + 1)}>
                                    <span className="page-item-btn-inner">
                                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M0.934461 0.491142C0.57648 0.849122 0.57648 1.42952 0.934461 1.7875L4.86961 5.72266L0.934461 9.65781C0.57648 10.0158 0.57648 10.5962 0.934461 10.9542C1.29244 11.3122 1.87284 11.3122 2.23082 10.9542L6.81416 6.37084C7.17214 6.01286 7.17214 5.43246 6.81416 5.07448L2.23082 0.491142C1.87284 0.133161 1.29244 0.133161 0.934461 0.491142Z" fill="#23235F" />
                                        </svg>
                                    </span>
                                </button>
                            </li>
                            <li >
                                <button className={`${userWiseData?.currentPage == userWiseData?.maxPage && "gen-action-btn-disable dis-"}last-btn`} disabled={userWiseData?.currentPage == userWiseData?.maxPage} onClick={() => changePage(userWiseData?.maxPage)}>
                                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.9346 6.49114C11.5766 6.84912 11.5766 7.42952 11.9346 7.7875L15.8697 11.7227L11.9346 15.6578C11.5766 16.0158 11.5766 16.5962 11.9346 16.9542C12.2926 17.3122 12.873 17.3122 13.2309 16.9542L17.8143 12.3708C18.1723 12.0129 18.1723 11.4325 17.8143 11.0745L13.2309 6.49114C12.873 6.13316 12.2926 6.13316 11.9346 6.49114Z" fill="#23235F" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.51796 6.49114C5.15998 6.84912 5.15998 7.42952 5.51796 7.7875L9.45311 11.7227L5.51796 15.6578C5.15998 16.0158 5.15998 16.5962 5.51796 16.9542C5.87594 17.3122 6.45634 17.3122 6.81432 16.9542L11.3977 12.3708C11.7556 12.0129 11.7556 11.4325 11.3977 11.0745L6.81432 6.49114C6.45634 6.13316 5.87594 6.13316 5.51796 6.49114Z" fill="#23235F" />
                                    </svg>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>}
        </div>
    }

    const renderComponent = () => {
        if (loading) {
            return <div className='w-full h-full bg-white'><TableSkeleton className='!h-full' /></div>
        } else if (errorOccured) {
            return <div className='w-full h-full bg-white'><TableLoader className='!p-[0] !h-full' loaderModalClassName='!h-full' loading={loading} isError={errorOccured} onRefresh={() => getData()} /></div>
        }

        return (
            <div className='min-h-[395px] h-full w-full bg-white text-fontBlack border border-borderSlateGrey'>
                <table className='w-full'>
                    <thead className='bg-white'>
                        <tr className='relative border-b border-borderSlateGrey'>
                            <th className='border-r border-borderSlateGrey text-xs font-semibold px-2 py-2 text-start'><LanguageTranslator>Full Name</LanguageTranslator></th>
                            <th className='border-r border-borderSlateGrey text-xs font-semibold px-2 py-2 text-start'><LanguageTranslator>Username</LanguageTranslator></th>
                            <th className='border-r border-borderSlateGrey text-xs font-semibold px-2 py-2 text-start' colSpan={3}><LanguageTranslator>Purchase Indent</LanguageTranslator></th>
                            <th className='border-r border-borderSlateGrey text-xs font-semibold px-2 py-2 text-start' colSpan={3}><LanguageTranslator>Purchase Order</LanguageTranslator></th>
                        </tr>
                        <tr className='relative border-b border-borderSlateGrey'>
                            <th className='border-r border-borderSlateGrey text-start text-[10px] font-semibold px-2 py-2'></th>
                            <th className='border-r border-borderSlateGrey text-start text-[10px] font-semibold px-2 py-2'></th>
                            <th className='border-r border-borderSlateGrey text-start text-[10px] font-semibold px-2 py-2'><LanguageTranslator>Quantity</LanguageTranslator></th>
                            <th className='border-r border-borderSlateGrey text-start text-[10px] font-semibold px-2 py-2'><LanguageTranslator>Count</LanguageTranslator></th>
                            <th className='border-r border-borderSlateGrey text-start text-[10px] font-semibold px-2 py-2'><LanguageTranslator>Amount</LanguageTranslator></th>
                            <th className='border-r border-borderSlateGrey text-start text-[10px] font-semibold px-2 py-2'><LanguageTranslator>Quantity</LanguageTranslator></th>
                            <th className='border-r border-borderSlateGrey text-start text-[10px] font-semibold px-2 py-2'><LanguageTranslator>Count</LanguageTranslator></th>
                            <th className='text-start text-[10px] font-semibold px-2 py-2'><LanguageTranslator>Amount</LanguageTranslator></th>
                        </tr>
                    </thead>
                    <tbody className='text-right'>
                        {tableData?.length == 0 && <tr><td colSpan={"100%"}><NoDataFound /></td></tr>}

                        {tableData?.map((row, index) => (
                            <tr key={index} className='border-b border-borderSlateGrey'>
                                <td className='group relative border-r border-borderSlateGrey px-2 py-2 text-xs font-normal text-left'>{row?.firstname} {row?.lastname}</td>
                                <td className='group relative border-r border-borderSlateGrey px-2 py-2 text-xs font-normal text-left'>{row?.created_by}</td>
                                <td className='group relative border-r border-borderSlateGrey px-2 py-2 text-xs font-normal'>
                                    {formatNumber(Number(row?.["pi_qty"])).short}
                                    {formatNumber(Number(row?.["pi_qty"])).full && <span className='generic-tooltip last:left-auto last:right-0 last:after:left-auto last:after:right-[15px] group-hover:opacity-100 group-hover:visible'>{formatNumber(Number(row?.["pi_qty"])).full}</span>}
                                </td>
                                <td className='group relative border-r border-borderSlateGrey px-2 py-2 text-xs font-normal'>
                                    {formatNumber(Number(row?.["pi_count"])).short}
                                    {formatNumber(Number(row?.["pi_count"])).full && <span className='generic-tooltip last:left-auto last:right-0 last:after:left-auto last:after:right-[15px] group-hover:opacity-100 group-hover:visible'>{formatNumber(Number(row?.["pi_count"])).full}</span>}
                                </td>
                                <td className='group relative border-r border-borderSlateGrey px-2 py-2 text-xs font-normal'>
                                    {formatNumber(Number(row?.["pi_amount"])).short}
                                    {formatNumber(Number(row?.["pi_amount"])).full && <span className='generic-tooltip last:left-auto last:right-0 last:after:left-auto last:after:right-[15px] group-hover:opacity-100 group-hover:visible'>{formatNumber(Number(row?.["pi_amount"])).full}</span>}
                                </td>
                                <td className='group relative border-r border-borderSlateGrey px-2 py-2 text-xs font-normal'>
                                    {formatNumber(Number(row?.["po_qty"])).short}
                                    {formatNumber(Number(row?.["po_qty"])).full && <span className='generic-tooltip last:left-auto last:right-0 last:after:left-auto last:after:right-[15px] group-hover:opacity-100 group-hover:visible'>{formatNumber(Number(row?.["po_qty"])).full}</span>}
                                </td>
                                <td className='group relative border-r border-borderSlateGrey px-2 py-2 text-xs font-normal'>
                                    {formatNumber(Number(row?.["po_count"])).short}
                                    {formatNumber(Number(row?.["po_count"])).full && <span className='generic-tooltip last:left-auto last:right-0 last:after:left-auto last:after:right-[15px] group-hover:opacity-100 group-hover:visible'>{formatNumber(Number(row?.["po_count"])).full}</span>}
                                </td>
                                <td className='group relative border-r border-borderSlateGrey px-2 py-2 text-xs font-normal'>
                                    {formatNumber(Number(row?.["po_amount"])).short}
                                    {formatNumber(Number(row?.["po_amount"])).full && <span className='generic-tooltip last:left-auto last:right-0 last:after:left-auto last:after:right-[15px] group-hover:opacity-100 group-hover:visible'>{formatNumber(Number(row?.["po_amount"])).full}</span>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            // {/* </AnimatePresence> */}
        )
    }

    return (
        <div className=''>
            <div className='grid grid-cols-[3fr_1fr] h-full gap-5 prodDashboardBottomSection'>
                <div className='order-tracking-dashboard-table text-fontBlack'>
                    <div className='px-[15px] py-2.5 mb-3 flex items-center justify-between gap-4 bg-white rounded-md'>
                        <LanguageTranslator tag='p' className='text-base font-semibold whitespace-nowrap mb-0'>User-wise Creation Statistics</LanguageTranslator>

                        {/* Render the right pagination here */}
                        {renderPagination()}
                    </div>
                    <div className='flex min-h-[395px] bg-white'>
                        {renderComponent()}
                    </div>
                </div>
                <div className="bg-white p-[12px] procDashboardBottom"
                    style={{ boxShadow: "0px 14px 25px 1px #E1E1E7" }}
                >
                    <div className='flex justify-between gap-2 items-start mb-3'>
                        <LanguageTranslator tag='h3' className='text-[15px] font-semibold mb-0 mt-[6px]'>Performance Analysis</LanguageTranslator>
                        <GenericInput
                            type="dropdown"
                            value={selectedItem?.displayName}
                            onChange={(data) => handleChange("itemCount", data)}
                            inputProps={() => provideProps("itemCount")}
                            iconRight={<Icons.DownArrowNew />}
                            genInputExtraClass="!w-[80px] !rounded-none"
                        />
                    </div>
                    <LanguageTranslator tag='p' className='text-[#7C7D7E] text-xs mb-3'>Showing the top-performing vendors and items up to date</LanguageTranslator>
                    <Radio.Group className='flex w-full text-xs text-center mb-3 whitespace-nowrap border-2 border-[#ECEEEF]' value={currentTab} onChange={(val) => handleChange("tab", val)}>
                        <Radio.Button className='flex items-center justify-center w-full text-xs border-none' value={"vendors"}><LanguageTranslator>Vendors</LanguageTranslator></Radio.Button>
                        <Radio.Button className='flex items-center justify-center w-full text-xs border-none' value={"items"}><LanguageTranslator>Items</LanguageTranslator></Radio.Button>
                    </Radio.Group>

                    {digiProcStore?.getPerformanceAnalysisData?.isLoading ? renderLoadingSkeleton() : <div className='max-h-[293px] pt-[8px] overflow-y-auto'>
                        {performanceAnalysisData?.map((item) =>
                            <div className='flex items-start gap-1.5 border-b border-[#E5E6EB] last:border-none'>
                                {Object.keys(performanceAnalysisObj?.[currentTab] || {}).includes('slname') && <div className='mt-[32px]'><Factory size={13} /></div>}
                                <div className={`py-2 flex-1 grid grid-cols-2 gap-x-2 ${Object.keys(performanceAnalysisObj?.[currentTab] || {}).includes('slname') ? 'second-tooltip-right' : 'total-amount-val'}`}>
                                    {Object.keys(performanceAnalysisObj?.[currentTab] || {})?.map((key, index) =>
                                        <div className={`performanceAnalysisItem ${key === 'slname' ? '' : ''}`}>
                                            <LanguageTranslator tag='label' className='text-[#8496A9] text-[9px] mb-0'>{performanceAnalysisObj?.[currentTab]?.[key]}</LanguageTranslator>
                                            <div className='group relative'>
                                                {/* <p className={`mb-0 text-red-900 ${key === 'slname' ? 'text-[13px] font-medium' : 'text-xs'}`} onClick={() => handleChange("viewVendorDetails", item)}>{["slcode", "slname", "hl1name"]?.some(k => key == k) ? item?.[key] || "" : formatNumber(item?.[key])?.short}</p> */}
                                                <p className={`mb-0 ${key === 'slname' ? 'text-[13px] font-medium' : 'text-xs'}`}>{["slcode", "slname", "hl1name"]?.some(k => key == k) ? item?.[key] || "" : formatNumber(item?.[key])?.short} {key === "otif" || key == "fulfill" ? "%": ""}</p>
                                                {!["slcode", "slname", "hl1name"]?.some(k => key == k) && formatNumber(item?.[key])?.full && <span className='generic-tooltip !left-[18px] group-hover:visible group-hover:opacity-100'>{formatNumber(item?.[key])?.full}</span>}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>}
                </div>
            </div>

            <div className='bg-white px-5 py-3 mt-5'
                style={{ boxShadow: "0px 14px 25px 1px #E1E1E7" }}
            >
                <div>
                    <div className='mb-3 flex items-center justify-between gap-6'>
                        <LanguageTranslator tag='h3' className='text-[15px] font-semibold mt-[2px]'>Indents & Orders Creation Statistics</LanguageTranslator>
                        <GenericInput
                            key="statisticsFilter"
                            type="range"
                            value={graphDataRange}
                            onChange={(data) => handleChange("statisticsFilter", data)}
                            inputProps={() => provideProps("statisticsFilter")}
                            genInputExtraClass="!w-[220px] !rounded-none"
                            hideDefaultRanges={false}
                            disabledDate={(val) => disabledDate(val)}
                            dependentFieldsObject={[graphDataRange]}
                        />
                    </div>
                    <div className='flex gap-4 items-center text-xs font-medium my-4'>
                        <div className='flex items-center gap-1.5'>
                            <div className='h-2.5 w-2.5 bg-[#FFB142]'></div>
                            <LanguageTranslator tag='span'>Indents Created</LanguageTranslator>
                        </div>
                        <div className='flex items-center gap-1.5'>
                            <div className='h-2.5 w-2.5 bg-[#FF793F]'></div>
                            <LanguageTranslator tag='span'>Indents Approved</LanguageTranslator>
                        </div>
                        <div className='flex items-center gap-1.5'>
                            <div className='h-2.5 w-2.5 bg-[#34ACE0]'></div>
                            <LanguageTranslator tag='span'>Order Created</LanguageTranslator>
                        </div>
                        <div className='flex items-center gap-1.5'>
                            <div className='h-2.5 w-2.5 bg-[#218C74]'></div>
                            <LanguageTranslator tag='span'>Orders Approved</LanguageTranslator>
                        </div>
                        {/* <div className='flex items-center gap-1.5'>
                            <div className='h-2.5 w-2.5 bg-[#474787]'></div>
                            <LanguageTranslator tag='span'>GRC Completed</LanguageTranslator>
                        </div> */}
                    </div>
                    {/* <p className='text-[#7C7D7E] text-xs mb-5'>This bar graph helps you identify the statistics for indent and order creation, including the quantities and amounts of the orders for comparision.</p> */}
                </div>
                {digiProcStore?.getPiPoCreationStatsData?.isLoading ? renderChartSkeletonLoader() :
                    <ResponsiveContainer width="100%" height={350}>
                        <BarChart
                            width={500}
                            height={200}
                            data={graphData}
                            margin={{
                                top: 20,
                                right: 30,
                                left: 0,
                                bottom: 5,
                            }}
                            barSize={33}
                        >
                            <CartesianGrid strokeDasharray={null} vertical={false} />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip content={<CustomTooltip />} />
                            <Bar dataKey="Indents Created" stackId="a" width={15} fill="#FFB142" isAnimationActive={false} />
                            <Bar dataKey="Indents Approved" stackId="a" width={15} fill="#FF793F" isAnimationActive={false} />
                            <Bar dataKey="Orders Created" stackId="a" width={15} fill="#34ACE0" isAnimationActive={false} />
                            <Bar dataKey="Orders Approved" stackId="a" width={15} fill="#218C74" isAnimationActive={false} />
                            {/* <Bar dataKey="GRC Completed" stackId="a" width={15} fill="#474787" isAnimationActive={false}/> */}
                        </BarChart>
                    </ResponsiveContainer>}
            </div>
        </div>
    )
}

export default ProcDashBottomSection